import {fetchStarter} from '../micro-frontend/fetch-starter';

const microFrontendName = document.currentScript.getAttribute('data-mf-name');
const isConnected = document.currentScript.getAttribute('data-is-connected') === 'true';
const fetchDisconnected = document.currentScript.getAttribute('data-fetch-disconnected') === 'true';

function isReallyConnected(microFrontendContent) {
    return microFrontendContent.querySelector('body').getAttribute('data-is-connected') !== 'false';
}

async function fetchMicroFrontend(microFrontendName, useCache = true) {
    const microFrontendURL = '/mf/' + microFrontendName + '/starter';

    const mfStarterCache = useCache ? (window.MICRO_FRONTEND_STARTER_CACHES || {})[microFrontendName] : null;

    const mfContentPromise = mfStarterCache
        ? Promise.resolve(mfStarterCache)
        : fetchStarter(microFrontendURL).then((htmlString) => {
              if (!htmlString) {
                  return null;
              }
              // Temporary element created to parse receive HTML and then take the appropriate bits of it
              const microFrontendContent = document.createElement('html');
              microFrontendContent.innerHTML = htmlString;
              return microFrontendContent;
          });

    let microFrontendContent = null;
    try {
        microFrontendContent = await mfContentPromise;
    } catch (e) {
        console.error(e);
    }

    (window.MICRO_FRONTEND_STARTER_CACHES || {})[microFrontendName] = null;

    // User can actually be disconnected but content here because of JSP cache
    if (!microFrontendContent || (!isReallyConnected(microFrontendContent) && !fetchDisconnected)) {
        return;
    }

    const hostHead = document.querySelector('head');
    const hostBody = document.querySelector('body');

    Array.from(microFrontendContent.querySelectorAll('link')).forEach((link) => {
        hostHead.appendChild(link);
    });
    Array.from(microFrontendContent.querySelectorAll('script')).forEach((script) => {
        // For security reasons, modern browsers won't just let us dump scripts coming from elsewhere, hence the copy.
        const scriptCopy = document.createElement('script');

        // Element.getAttributeNames isn't supported by Samsung Internet < 8.2
        for (let i = 0, attrs = script.attributes, len = attrs.length; i < len; i++) {
            const attr = attrs[i];
            scriptCopy.setAttribute(attr.name, attr.value);
        }

        // Dynamically added scripts are async by default.
        // We don't want them to be async unless specified (so that scripts order is assured)
        if (!scriptCopy.getAttribute('async')) {
            scriptCopy.async = false;
        }

        // https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute#retrieving_nonce_values
        // For security reasons, CSP nonces from non-script sources, such as CSS selectors
        // and `.getAttribute("nonce")` calls are hidden.
        script.nonce && (scriptCopy.nonce = script.nonce);

        if (!script.src && script.innerHTML) {
            scriptCopy.innerHTML = script.innerHTML;
        }

        try {
            hostBody.appendChild(scriptCopy);
        } catch (e) {
            /* SyntaxError is very likely caused by a duplicate script that is re-declaring an identifier.
             * Skip to next script.
             */
            if (!(e instanceof SyntaxError)) {
                throw e;
            }
        }
    });
}

function main() {
    if (!isConnected && !fetchDisconnected) {
        window.addEventListener(
            'user:connected',
            () => {
                // eslint-disable-next-line
                console.log('ℹ️ isConnected: ', isConnected);
                fetchMicroFrontend(microFrontendName, false);
            },
            {once: true},
        );
        return;
    }

    if (!(window.Hop && window.Hop.events)) {
        window.addEventListener(
            'hop:eventsReady',
            () => {
                // eslint-disable-next-line
                console.log('ℹ️ isConnected: ', isConnected);
                fetchMicroFrontend(microFrontendName);
            },
            {once: true},
        );
    } else {
        // eslint-disable-next-line
        console.log('ℹ️ isConnected: ', isConnected);
        fetchMicroFrontend(microFrontendName);
    }
}

main();
